module.exports = __webpack_public_path__ + "media/img/pages/profile/fenaco ger 6-e2184e957631dacbab29e99a6a09a5cc.jpg";